import { render, staticRenderFns } from "./CardProject.vue?vue&type=template&id=1a2ae422"
import script from "./CardProject.vue?vue&type=script&lang=js"
export * from "./CardProject.vue?vue&type=script&lang=js"
import style0 from "./CardProject.vue?vue&type=style&index=0&id=1a2ae422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports